import { useEffect } from "react";

export function useFixReportViewerDateFormat() {
    useEffect(() => {
        const $ = (window as any).$;
        if (!$) return;

        const format = "dd/MM/yyyy";
        const processed = new WeakSet<any>();

        const applyOnce = () => {
            let appliedAny = false;

            const root = document.getElementById("reportViewer1");
            if (!root) return false;

            const inputs = root.querySelectorAll<HTMLInputElement>(
                ".k-datepicker input, .k-datetimepicker input, .k-dateinput input"
            );

            inputs.forEach((input) => {
                const widget =
                    $(input).data("kendoDatePicker") ||
                    $(input).data("kendoDateTimePicker") ||
                    $(input).data("kendoDateInput");

                if (!widget || processed.has(widget)) return;

                processed.add(widget);
                appliedAny = true;

                widget.setOptions({ format });

                const value = widget.value?.();
                if (value instanceof Date) {
                    widget.value(value);
                }
            });

            return appliedAny;
        };

        if (applyOnce()) return;

        const observer = new MutationObserver(() => {
            if (applyOnce()) observer.disconnect();
        });

        observer.observe(document.body, { childList: true, subtree: true });

        return () => observer.disconnect();
    }, []);
}

export function renderingEnd() {
    const container = document.getElementById("reportViewer1");
    if (!container) return;

    const datepickers = container.querySelectorAll("[data-role='datepicker']");

    datepickers.forEach(el => {
        const widget = (el as any).kendoDatePicker;
        if (widget) {
            widget.setOptions({ format: "dd/MM/yyyy" });
        }
    });
}